/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import CustomerListCard from './CustomerListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'

function CustomerListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'contacts',
    defaultMessage: 'Contacts'
  })

  const [searchParams, setSearchParams] = useQueryParams()

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerListCard
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default CustomerListPage
